/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  AWSDate: Date;
  Long: number;
};

export type Abilities = {
  __typename?: 'Abilities';
  canChangeCampaignUnit?: Maybe<Scalars['Boolean']>;
  canCreateCampaign?: Maybe<Scalars['Boolean']>;
  canCreateStory?: Maybe<Scalars['Boolean']>;
  canGlobalize?: Maybe<Scalars['Boolean']>;
  canLocalize?: Maybe<Scalars['Boolean']>;
  canViewAdminTab?: Maybe<Scalars['Boolean']>;
  canViewGlobalManagerPages?: Maybe<Scalars['Boolean']>;
  canViewLocalizerPages?: Maybe<Scalars['Boolean']>;
  showMyFilter?: Maybe<Scalars['Boolean']>;
};

export type AlterName = Entity & {
  __typename?: 'AlterName';
  artist_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  product_id?: Maybe<Scalars['Int']>;
  product_name?: Maybe<Scalars['String']>;
};

export type AlterNameCreate = {
  artist_name: Scalars['String'];
  product_id: Scalars['Int'];
  product_name: Scalars['String'];
};

export type Artist = Entity & {
  __typename?: 'Artist';
  bio?: Maybe<Scalars['String']>;
  campaigns?: Maybe<Array<Campaign>>;
  created_at?: Maybe<Scalars['String']>;
  facebook_id?: Maybe<Scalars['String']>;
  gcdm_info?: Maybe<GcdmInfo>;
  gfk_id?: Maybe<Scalars['Int']>;
  gps_status?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image_url_data?: Maybe<ImageUrlData>;
  instagram_id?: Maybe<Scalars['String']>;
  label?: Maybe<Label>;
  label_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  opus_id?: Maybe<Scalars['String']>;
  products?: Maybe<Array<GlobalProduct>>;
  social_media_kpi_facebook?: Maybe<Scalars['Int']>;
  social_media_kpi_instagram?: Maybe<Scalars['Int']>;
  social_media_kpi_spotify?: Maybe<Scalars['Int']>;
  social_media_kpi_tiktok?: Maybe<Scalars['Int']>;
  social_media_kpi_twitter?: Maybe<Scalars['Int']>;
  social_media_kpi_youtube?: Maybe<Scalars['Int']>;
  spotify_id?: Maybe<Scalars['String']>;
  spotify_url?: Maybe<Scalars['String']>;
  tiktok_id?: Maybe<Scalars['String']>;
  twitter_id?: Maybe<Scalars['String']>;
  youtube_id?: Maybe<Scalars['String']>;
};

export type ArtistAssignInput = {
  artistId: Scalars['String'];
  projectId: Scalars['String'];
};

export type ArtistAssignResponse = {
  __typename?: 'ArtistAssignResponse';
  result?: Maybe<Scalars['String']>;
};

export type ArtistAssigns = Entity & {
  __typename?: 'ArtistAssigns';
  artistId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  projectId?: Maybe<Scalars['String']>;
};

export type ArtistConcert = {
  __typename?: 'ArtistConcert';
  attendees?: Maybe<Scalars['Int']>;
  cityName?: Maybe<Scalars['String']>;
  countryId: Scalars['String'];
  countryName: Scalars['String'];
  date: Scalars['String'];
  dateStatus?: Maybe<Scalars['String']>;
  stateName?: Maybe<Scalars['String']>;
  tourName?: Maybe<Scalars['String']>;
  venue?: Maybe<Scalars['String']>;
};

export type ArtistCreate = {
  bio?: InputMaybe<Scalars['String']>;
  facebook_id?: InputMaybe<Scalars['String']>;
  gfk_id?: InputMaybe<Scalars['Int']>;
  gps_status?: InputMaybe<Scalars['String']>;
  label_id: Scalars['String'];
  name: Scalars['String'];
  opus_id?: InputMaybe<Scalars['String']>;
};

export type ArtistProduct = {
  __typename?: 'ArtistProduct';
  dv_entity_id?: Maybe<Scalars['String']>;
  dv_group_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  primaryArtistName?: Maybe<Scalars['String']>;
  release_date?: Maybe<Scalars['String']>;
  thumbnailUrl?: Maybe<Scalars['String']>;
  type?: Maybe<ArtistProductType>;
  versionCount?: Maybe<Scalars['Int']>;
};

export type ArtistProductSearchResponse = {
  __typename?: 'ArtistProductSearchResponse';
  products?: Maybe<Array<Maybe<ArtistProduct>>>;
  total?: Maybe<Scalars['Int']>;
};

export enum ArtistProductType {
  Album = 'album',
  Track = 'track'
}

export type ArtistUpdate = {
  bio?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['String']>;
  facebook_id?: InputMaybe<Scalars['String']>;
  gfk_id?: InputMaybe<Scalars['Int']>;
  gps_status?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  label_id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  opus_id?: InputMaybe<Scalars['String']>;
  spotify_url?: InputMaybe<Scalars['String']>;
};

export type ArtistsResponse = {
  __typename?: 'ArtistsResponse';
  artists: Array<Artist>;
  total?: Maybe<Scalars['String']>;
};

export enum Chart_Frequency {
  Daily = 'DAILY',
  Weekly = 'WEEKLY'
}

export enum Chart_Type {
  Airplay = 'AIRPLAY',
  Dsp = 'DSP',
  Official = 'OFFICIAL'
}

export type Campaign = Entity & {
  __typename?: 'Campaign';
  active?: Maybe<Scalars['Boolean']>;
  artist?: Maybe<Artist>;
  artist_id?: Maybe<Scalars['Int']>;
  campaign_id?: Maybe<Scalars['String']>;
  children?: Maybe<Array<Campaign>>;
  created_at?: Maybe<Scalars['String']>;
  editable?: Maybe<Scalars['Boolean']>;
  feeds?: Maybe<Array<Maybe<Feed>>>;
  // gcdmLabel?: Maybe<Scalars['String']>;
  genre_info?: Maybe<CampaignGenre>;
  globalAbilities?: Maybe<GlobalProjectAbilities>;
  global_status?: Maybe<GlobalStatus>;
  id?: Maybe<Scalars['String']>;
  info?: Maybe<Scalars['String']>;
  isGlobal?: Maybe<Scalars['Boolean']>;
  isaac_url?: Maybe<Array<Maybe<Isaac>>>;
  label_id?: Maybe<Scalars['String']>;
  main_product_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  original_campaign?: Maybe<Campaign>;
  original_campaign_id?: Maybe<Scalars['String']>;
  owner_id?: Maybe<Scalars['Int']>;
  parent?: Maybe<Campaign>;
  parent_id?: Maybe<Scalars['String']>;
  products?: Maybe<Array<Maybe<Product>>>;
  project_id?: Maybe<Scalars['String']>;
  story_pinned_at?: Maybe<Scalars['String']>;
  story_pinned_by?: Maybe<User>;
  story_pinned_by_id?: Maybe<Scalars['Int']>;
  story_pinned_id?: Maybe<Scalars['Int']>;
  success_stories_count?: Maybe<Scalars['Int']>;
  team_info?: Maybe<Scalars['String']>;
  unit?: Maybe<Unit>;
  unit_id?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
  zone?: Maybe<Label>;
};

export type CampaignByName = {
  __typename?: 'CampaignByName';
  campaigns?: Maybe<Array<Maybe<Campaign>>>;
};

export type CampaignCreate = {
  artist_id: Scalars['String'];
  info?: InputMaybe<Scalars['String']>;
  isaac_url?: InputMaybe<Array<InputMaybe<IsaacInput>>>;
  label_id: Scalars['String'];
  main_product_id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  products?: InputMaybe<Array<InputMaybe<ProductLocalCreateInput>>>;
  project_id?: InputMaybe<Scalars['String']>;
  team_info?: InputMaybe<Scalars['String']>;
  unit_id: Scalars['String'];
};

export type CampaignGenre = {
  __typename?: 'CampaignGenre';
  company?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  genre?: Maybe<Scalars['String']>;
};

export type CampaignLocalize = {
  label_id: Scalars['String'];
  parent_id: Scalars['String'];
};

export type CampaignStatistic = {
  __typename?: 'CampaignStatistic';
  count?: Maybe<Array<Maybe<CampaignStatisticCount>>>;
  countByRange?: Maybe<Array<Maybe<CampaignStatisticCountByRange>>>;
};

export type CampaignStatisticCount = {
  __typename?: 'CampaignStatisticCount';
  active?: Maybe<Scalars['Boolean']>;
  label_id?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  unit_id?: Maybe<Scalars['String']>;
};

export type CampaignStatisticCountByRange = {
  __typename?: 'CampaignStatisticCountByRange';
  count?: Maybe<Scalars['Int']>;
  label_id?: Maybe<Scalars['String']>;
  range?: Maybe<Scalars['String']>;
  unit_id?: Maybe<Scalars['String']>;
};

export type CampaignTagFilter = {
  id?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  order_number?: InputMaybe<Scalars['Int']>;
};

export type CampaignUpdate = {
  artist_id?: InputMaybe<Scalars['Int']>;
  global_status?: InputMaybe<GlobalStatus>;
  id: Scalars['String'];
  info?: InputMaybe<Scalars['String']>;
  isaac_url?: InputMaybe<Array<InputMaybe<IsaacInput>>>;
  label_id?: InputMaybe<Scalars['Int']>;
  main_product_id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  owner_id?: InputMaybe<Scalars['Int']>;
  project_id?: InputMaybe<Scalars['String']>;
  team_info?: InputMaybe<Scalars['String']>;
  unit_id?: InputMaybe<Scalars['Int']>;
};

export type CampaignUpdateTeamInfo = {
  id: Scalars['String'];
  team_info: Scalars['String'];
};

export type CampaignViewsInput = {
  space_id: Scalars['String'];
};

export type CampaignsFilters = {
  archived?: InputMaybe<Scalars['String']>;
  countryCode: Scalars['String'];
  followed?: InputMaybe<Scalars['String']>;
  global_status?: InputMaybe<Array<InputMaybe<GlobalStatus>>>;
  isParent?: InputMaybe<Scalars['Boolean']>;
  label_id?: InputMaybe<Scalars['String']>;
  owners?: InputMaybe<Scalars['String']>;
  space_id?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<CampaignTagFilter>>>;
  unit_id?: InputMaybe<Scalars['String']>;
};

export type Chart = Entity & {
  __typename?: 'Chart';
  artist?: Maybe<Scalars['String']>;
  artist_id?: Maybe<Scalars['Int']>;
  campaign_id?: Maybe<Scalars['Int']>;
  chart?: Maybe<Scalars['String']>;
  configuration?: Maybe<Scalars['String']>;
  country_code?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  duplicate?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  label_id?: Maybe<Scalars['String']>;
  origin?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  peak?: Maybe<Scalars['Int']>;
  prerank?: Maybe<Scalars['Int']>;
  product_id?: Maybe<Scalars['Int']>;
  rank?: Maybe<Scalars['Int']>;
  received_date?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ChartConfiguration = Entity & {
  __typename?: 'ChartConfiguration';
  chart_ids?: Maybe<Array<Maybe<Scalars['Int']>>>;
  country_code: Scalars['String'];
  created_at?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  label_id: Scalars['String'];
  updated_at?: Maybe<Scalars['String']>;
};

export type ChartConfigurationCreateInput = {
  chart_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  country_code: Scalars['String'];
  label_id: Scalars['String'];
};

export type ChartConfigurationUpdateInput = {
  chart_ids: Array<InputMaybe<Scalars['Int']>>;
  country_code: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  label_id: Scalars['String'];
};

export type ChartFreshness = {
  __typename?: 'ChartFreshness';
  chart?: Maybe<Scalars['String']>;
  configuration?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
};

export type ChartLookup = Entity & {
  __typename?: 'ChartLookup';
  chart?: Maybe<Scalars['String']>;
  configuration?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  import_limit?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  origin?: Maybe<Scalars['String']>;
  period?: Maybe<Scalars['String']>;
};

export type ChartName = {
  __typename?: 'ChartName';
  artist?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export enum ChartNameTypeParameter {
  Artist = 'artist',
  Product = 'product'
}

export type Comment = Entity & {
  __typename?: 'Comment';
  argument_id: Scalars['Int'];
  author: User;
  author_id: Scalars['Int'];
  campaign_id: Scalars['Int'];
  created_at: Scalars['String'];
  id: Scalars['String'];
  lastEditor?: Maybe<User>;
  last_editor_id?: Maybe<Scalars['Int']>;
  text: Scalars['String'];
  updated_at: Scalars['String'];
};

export type Concert = {
  __typename?: 'Concert';
  attendees: Scalars['String'];
  cityName: Scalars['String'];
  countryName: Scalars['String'];
  country_id: Scalars['String'];
  date: Scalars['String'];
  dateStatus: Scalars['String'];
  id: Scalars['ID'];
  managerStatus: Scalars['String'];
  stateName: Scalars['String'];
  tourName: Scalars['String'];
  venue: Scalars['String'];
};

export type ConcertArtist = {
  __typename?: 'ConcertArtist';
  artist?: Maybe<Artist>;
  concert?: Maybe<Concert>;
};

export type CountCampaignViewsInput = {
  campaign_id: Scalars['String'];
};

export type CountCampaignViewsResponse = {
  __typename?: 'CountCampaignViewsResponse';
  success: Scalars['Boolean'];
};

export type Country = {
  __typename?: 'Country';
  code: Scalars['String'];
  name: Scalars['String'];
};

export type CreateLabelTemplate = {
  label_id: Scalars['Int'];
  template: Scalars['String'];
  template_type?: InputMaybe<LabelTemplateType>;
};

export type DvChart = {
  __typename?: 'DVChart';
  chartDate?: Maybe<Scalars['String']>;
  chartName?: Maybe<Scalars['String']>;
  chartType?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  countryName?: Maybe<Scalars['String']>;
  customerName?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<DvChartItem>>>;
};

export type DvChartItem = {
  __typename?: 'DVChartItem';
  artist?: Maybe<Scalars['String']>;
  artist_id?: Maybe<Scalars['Int']>;
  campaign_id?: Maybe<Scalars['Int']>;
  configuration?: Maybe<Scalars['String']>;
  dv_entity_id?: Maybe<Scalars['String']>;
  label_id?: Maybe<Scalars['Int']>;
  peak?: Maybe<Scalars['Int']>;
  prerank?: Maybe<Scalars['Int']>;
  product_id?: Maybe<Scalars['Int']>;
  rank?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

export enum DateRangeParameter {
  Month = 'month',
  Week = 'week'
}

export type DeleteGlobalInboxItemInput = {
  id: Scalars['String'];
};

export type Entity = {
  id?: Maybe<Scalars['String']>;
};

export type Fact = Entity & {
  __typename?: 'Fact';
  chart?: Maybe<Scalars['String']>;
  country_code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  peak?: Maybe<Scalars['Int']>;
  position_current?: Maybe<Scalars['Int']>;
  position_current_at?: Maybe<Scalars['String']>;
  position_last?: Maybe<Scalars['Int']>;
  product_id?: Maybe<Scalars['Int']>;
  source_origin?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
};

export type FactSource = Entity & {
  __typename?: 'FactSource';
  id?: Maybe<Scalars['String']>;
  origin?: Maybe<Scalars['String']>;
  sources?: Maybe<Array<Maybe<SourceItem>>>;
};

export type Feed = Entity & {
  __typename?: 'Feed';
  argument_type: Scalars['String'];
  artist: Artist;
  author?: Maybe<User>;
  author_id?: Maybe<Scalars['Int']>;
  body?: Maybe<Scalars['String']>;
  body_updated_at?: Maybe<Scalars['String']>;
  campaign: Campaign;
  campaign_id: Scalars['Int'];
  comments?: Maybe<Array<Comment>>;
  created_at: Scalars['String'];
  editable: Scalars['Boolean'];
  fact_id?: Maybe<Scalars['String']>;
  facts?: Maybe<Fact>;
  gallery?: Maybe<Array<Scalars['String']>>;
  global_status?: Maybe<GlobalStatus>;
  id: Scalars['String'];
  inboxId?: Maybe<Scalars['String']>;
  lastEditor?: Maybe<User>;
  pinned?: Maybe<Scalars['Boolean']>;
  pinned_at?: Maybe<Scalars['String']>;
  pinned_by?: Maybe<Scalars['String']>;
  product?: Maybe<Product>;
  product_id?: Maybe<Scalars['String']>;
  properties?: Maybe<Scalars['String']>;
  review_status?: Maybe<ReviewStatus>;
  shared_from?: Maybe<Campaign>;
  tags?: Maybe<Array<Tag>>;
  title: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  updated_at: Scalars['String'];
};

export type FeedCreate = {
  argument_type?: InputMaybe<Scalars['String']>;
  author_id?: InputMaybe<Scalars['Int']>;
  body: Scalars['String'];
  campaign_id: Scalars['Int'];
  fact_id?: InputMaybe<Scalars['Int']>;
  gallery?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  product_id?: InputMaybe<Scalars['Int']>;
  properties?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<TagInput>>>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type FeedFilters = {
  country?: InputMaybe<Scalars['String']>;
  followed?: InputMaybe<Scalars['String']>;
  label_id?: InputMaybe<Scalars['String']>;
  owners?: InputMaybe<Scalars['String']>;
  range?: InputMaybe<Scalars['String']>;
  space?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<FeedTagFilter>>>;
  text?: InputMaybe<Scalars['String']>;
  unit_id?: InputMaybe<Scalars['String']>;
};

export type FeedGlobalCreateUpdate = {
  author_id?: InputMaybe<Scalars['Int']>;
  body?: InputMaybe<Scalars['String']>;
  campaign_id?: InputMaybe<Scalars['Int']>;
  comments?: InputMaybe<GlobalCommentInput>;
  fact_id?: InputMaybe<Scalars['Int']>;
  gallery?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  global_status?: InputMaybe<GlobalStatus>;
  id?: InputMaybe<Scalars['Int']>;
  product_id?: InputMaybe<Scalars['Int']>;
  properties?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<TagInput>>>;
  title?: InputMaybe<Scalars['String']>;
};

export type FeedResponse = {
  __typename?: 'FeedResponse';
  feeds: Array<Feed>;
  total?: Maybe<Scalars['String']>;
};

export type FeedTagFilter = {
  id?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  order_number?: InputMaybe<Scalars['Int']>;
};

export type FeedUpdate = {
  body?: InputMaybe<Scalars['String']>;
  campaign_id?: InputMaybe<Scalars['String']>;
  fact_id?: InputMaybe<Scalars['Int']>;
  gallery?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id: Scalars['Int'];
  product_id?: InputMaybe<Scalars['Int']>;
  properties?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<TagInput>>>;
  title?: InputMaybe<Scalars['String']>;
};

export type FeedsCount = {
  __typename?: 'FeedsCount';
  value?: Maybe<Scalars['Int']>;
};

export enum FilterArchivedStatus {
  Hide = 'hide',
  Show = 'show'
}

export type FilterFactSource = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type Finance = Entity & {
  __typename?: 'Finance';
  expl_value?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  m_and_n_value?: Maybe<Scalars['Int']>;
  merch_pap_value?: Maybe<Scalars['Int']>;
  pap_at_value?: Maybe<Scalars['Int']>;
  pap_ch_value?: Maybe<Scalars['Int']>;
  pap_de_value?: Maybe<Scalars['Int']>;
  project_id?: Maybe<Scalars['String']>;
  rc_value?: Maybe<Scalars['Int']>;
  trade_mkt_value?: Maybe<Scalars['Int']>;
};

export type Follow = Entity & {
  __typename?: 'Follow';
  campaign_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

export type FollowInput = {
  campaign_id: Scalars['String'];
};

export type FollowersCount = {
  __typename?: 'FollowersCount';
  count?: Maybe<Scalars['String']>;
};

export type GcdmArtist = {
  __typename?: 'GcdmArtist';
  artistDisplayTitle?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  formatCode?: Maybe<Scalars['String']>;
  genre?: Maybe<Scalars['String']>;
  opusId?: Maybe<Scalars['String']>;
};

export type GcdmArtistSearchInput = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  searchTerm: Scalars['String'];
};

export type GcdmArtistSearchResponse = {
  __typename?: 'GcdmArtistSearchResponse';
  items?: Maybe<Array<Maybe<GcdmArtist>>>;
  total?: Maybe<Scalars['Int']>;
};

export type GcdmInfo = {
  __typename?: 'GcdmInfo';
  company?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  genre?: Maybe<Scalars['String']>;
};

export type GcdmItem = {
  __typename?: 'GcdmItem';
  artistDisplayTitle: Scalars['String'];
  artistId: Scalars['String'];
  displayTitle: Scalars['String'];
  gpid_list: Array<Maybe<Scalars['String']>>;
  releaseDate?: Maybe<Scalars['String']>;
  subType: Array<Maybe<Scalars['String']>>;
  type: Array<Maybe<Scalars['String']>>;
};

export type GcdmMatch = {
  __typename?: 'GcdmMatch';
  artistDisplayTitle: Scalars['String'];
  displayTitle: Scalars['String'];
  dv_entity_id?: Maybe<Scalars['String']>;
  dv_group_id?: Maybe<Scalars['String']>;
  gpid_list: Array<Maybe<Scalars['String']>>;
};

export type GcdmProductSearchInput = {
  artistName: Scalars['String'];
  artistOpusId?: InputMaybe<Scalars['String']>;
  configuration: ProductType;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  productName: Scalars['String'];
};

export type GcdmProductSearchResponse = {
  __typename?: 'GcdmProductSearchResponse';
  items?: Maybe<Array<Maybe<GcdmItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export enum GcdmProductType {
  Album = 'album',
  All = 'all',
  Track = 'track'
}

export type GetCampaignViewsInput = {
  label_id?: InputMaybe<Scalars['String']>;
  space_id?: InputMaybe<Scalars['String']>;
};

export type GetCampaignViewsResponse = {
  __typename?: 'GetCampaignViewsResponse';
  campaign: Campaign;
  views: Scalars['Int'];
};

export type GetChartsByLabelIdAndCountryResponse = {
  __typename?: 'GetChartsByLabelIdAndCountryResponse';
  chart?: Maybe<ChartLookup>;
  data?: Maybe<Array<Maybe<Chart>>>;
};

export type GetDvChartsInput = {
  chartFrequency?: InputMaybe<Chart_Frequency>;
  chartType?: InputMaybe<Array<InputMaybe<Chart_Type>>>;
  countryCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  productType?: InputMaybe<ArtistProductType>;
  trackLimit?: InputMaybe<Scalars['Int']>;
};

export type GetDvChartsResponse = {
  __typename?: 'GetDVChartsResponse';
  charts: Array<Maybe<DvChart>>;
  totalChartsCount: Scalars['Int'];
};

export type GetUpcomingConcertsInput = {
  labelId?: InputMaybe<Scalars['String']>;
  spaceId?: InputMaybe<Scalars['String']>;
};

export type GetUpcomingConcertsResponse = {
  __typename?: 'GetUpcomingConcertsResponse';
  concerts: Array<ConcertArtist>;
  totalConcertCount: Scalars['Int'];
};

export type GlobalCommentInput = {
  campaign_id: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  text: Scalars['String'];
};

export type GlobalInboxItem = Entity & {
  __typename?: 'GlobalInboxItem';
  argument_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  review_status?: Maybe<ReviewStatus>;
  story?: Maybe<Feed>;
  updated_at?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
};

export type GlobalInboxItemCreate = {
  argument_id: Scalars['Int'];
  message: Scalars['String'];
};

export type GlobalInboxItemUpdate = {
  argument_id: Scalars['Int'];
  comment?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  status: GlobalStatus;
};

export type GlobalInboxResponse = {
  __typename?: 'GlobalInboxResponse';
  items: Array<GlobalInboxItem>;
  total: Scalars['Int'];
};

export type GlobalProduct = Entity & {
  __typename?: 'GlobalProduct';
  configuration?: Maybe<Scalars['String']>;
  dv_entity_id?: Maybe<Scalars['String']>;
  dv_group_id?: Maybe<Scalars['String']>;
  feeds?: Maybe<Array<Maybe<Feed>>>;
  gps_status?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  locals?: Maybe<Array<Maybe<LocalProduct>>>;
  name?: Maybe<Scalars['String']>;
};

export type GlobalProjectAbilities = {
  __typename?: 'GlobalProjectAbilities';
  canEditGlobalProjectInfo?: Maybe<Scalars['Boolean']>;
  canEditGlobalTeamInfo?: Maybe<Scalars['Boolean']>;
  editable?: Maybe<Scalars['Boolean']>;
};

export enum GlobalStatus {
  None = 'NONE',
  Preparing = 'PREPARING',
  Published = 'PUBLISHED'
}

export type Isaac = Entity & {
  __typename?: 'ISAAC';
  id?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type IsaacInput = {
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type ImageUrlData = {
  __typename?: 'ImageUrlData';
  headerUrl?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  thumbnailUrl?: Maybe<Scalars['String']>;
};

export type ImportConcertsResponse = {
  __typename?: 'ImportConcertsResponse';
  success: Scalars['Boolean'];
};

export type InboxFilters = {
  campaign_ids: Array<Scalars['String']>;
  label_id?: InputMaybe<Scalars['String']>;
  range?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<FeedTagFilter>>>;
  text?: InputMaybe<Scalars['String']>;
};

export type InfoMessage = Entity & {
  __typename?: 'InfoMessage';
  active?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  messageType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
};

export type InfoMessageUpdate = {
  active: Scalars['Boolean'];
  id: Scalars['String'];
  message: Scalars['String'];
};

export type Label = Entity & {
  __typename?: 'Label';
  alias: Scalars['String'];
  country_codes: Array<Scalars['String']>;
  id: Scalars['String'];
  max_radio_stations?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  units: Array<Unit>;
};

export type LabelFollow = Entity & {
  __typename?: 'LabelFollow';
  id?: Maybe<Scalars['String']>;
  label_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

export type LabelFollowInput = {
  label_id: Scalars['String'];
};

export type LabelInput = {
  alias: Scalars['String'];
  country_codes?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  max_radio_stations?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type LabelTagsInput = {
  labelId?: InputMaybe<Scalars['String']>;
  spaceId?: InputMaybe<Scalars['String']>;
};

export type LabelTemplate = Entity & {
  __typename?: 'LabelTemplate';
  id?: Maybe<Scalars['String']>;
  label_id?: Maybe<Scalars['Int']>;
  template?: Maybe<Scalars['String']>;
  template_type: LabelTemplateType;
};

export enum LabelTemplateType {
  CampaignInfo = 'campaign_info',
  StoryGuide = 'story_guide',
  TeamInfo = 'team_info'
}

export type LocalProduct = Entity & {
  __typename?: 'LocalProduct';
  active?: Maybe<Scalars['Boolean']>;
  campaign_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  label_id?: Maybe<Scalars['String']>;
  main?: Maybe<Scalars['Boolean']>;
  publish_date?: Maybe<Scalars['String']>;
};

export type Mail = {
  __typename?: 'Mail';
  message?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  activateCampaign?: Maybe<Campaign>;
  archiveCampaign?: Maybe<Campaign>;
  assignArtist?: Maybe<ArtistAssignResponse>;
  assignTag?: Maybe<TagAssignResponse>;
  assignUserOktaGroup?: Maybe<OktaUserGroupResponse>;
  clearNotifications?: Maybe<NotificationDeleteResponse>;
  confirmProductChartMatch?: Maybe<Scalars['Int']>;
  countCampaignViews?: Maybe<CountCampaignViewsResponse>;
  createAlterName?: Maybe<AlterName>;
  createArtist?: Maybe<Artist>;
  createCampaign?: Maybe<Campaign>;
  createChartConfiguration?: Maybe<ChartConfiguration>;
  createComment: Comment;
  createFeed?: Maybe<Feed>;
  createGlobalInboxItem?: Maybe<Feed>;
  createLabel?: Maybe<Label>;
  createLabelTemplate?: Maybe<LabelTemplate>;
  createLocalProduct?: Maybe<Product>;
  createOktaUser?: Maybe<OktaUser>;
  createProducts?: Maybe<Array<Maybe<Product>>>;
  createSpace?: Maybe<Space>;
  createTag?: Maybe<Tag>;
  createUnit?: Maybe<Unit>;
  createUser: User;
  deleteArtist?: Maybe<Artist>;
  deleteCampaign?: Maybe<Campaign>;
  deleteChartConfiguration?: Maybe<ChartConfiguration>;
  deleteGlobalInboxItem?: Maybe<GlobalInboxItem>;
  deleteLabel?: Maybe<Label>;
  deleteLabelTemplate?: Maybe<LabelTemplate>;
  deleteNotification?: Maybe<NotificationDeleteResponse>;
  deleteNotificationsV2?: Maybe<NotificationDeleteResponse>;
  deleteSpace?: Maybe<Space>;
  deleteTag?: Maybe<Tag>;
  deleteUnit?: Maybe<Unit>;
  deleteUser: User;
  editComment: Comment;
  followCampaign?: Maybe<Follow>;
  followLabel?: Maybe<LabelFollow>;
  followTag?: Maybe<TagFollow>;
  globalizeCampaign?: Maybe<Campaign>;
  localizeCampaign?: Maybe<Campaign>;
  makeStoryGlobal?: Maybe<Feed>;
  pinStory?: Maybe<Campaign>;
  processGlobalInboxItem?: Maybe<GlobalInboxItem>;
  publishGlobalCampaign?: Maybe<Campaign>;
  removeAlterName?: Maybe<AlterName>;
  removeCampaign?: Maybe<Campaign>;
  removeComment?: Maybe<Comment>;
  removeFeed?: Maybe<Feed>;
  removeLocalProduct?: Maybe<Product>;
  removeProduct?: Maybe<Product>;
  report?: Maybe<Mail>;
  restoreUser: User;
  selectCreateGlobalFeed?: Maybe<Feed>;
  setSpotifyArtistUrl?: Maybe<Artist>;
  subscribeToPushNotifications?: Maybe<Scalars['String']>;
  unSubscribeFromPushNotifications?: Maybe<Scalars['String']>;
  unassignArtist?: Maybe<ArtistAssignResponse>;
  unassignTag?: Maybe<TagAssignResponse>;
  unfollowCampaign?: Maybe<Follow>;
  unfollowLabel?: Maybe<LabelFollow>;
  unfollowTag?: Maybe<TagFollow>;
  unpinStory?: Maybe<Campaign>;
  updateArtist?: Maybe<Artist>;
  updateCampaign?: Maybe<Campaign>;
  updateCampaignTeamInfo?: Maybe<Campaign>;
  updateChartConfiguration?: Maybe<ChartConfiguration>;
  updateFactSourceItem: SourceItem;
  updateFeed?: Maybe<Feed>;
  updateFeedCampaign?: Maybe<Feed>;
  updateGlobalCampaign?: Maybe<Campaign>;
  updateInfoMessage?: Maybe<InfoMessage>;
  updateLabel?: Maybe<Label>;
  updateLabelTemplate?: Maybe<LabelTemplate>;
  updateLocalProduct?: Maybe<Product>;
  updateProduct?: Maybe<Product>;
  updateSpace?: Maybe<Space>;
  updateTag?: Maybe<Tag>;
  updateUnit?: Maybe<Unit>;
  updateUser: User;
  wipeUser?: Maybe<User>;
};


export type MutationActivateCampaignArgs = {
  id: Scalars['String'];
};


export type MutationArchiveCampaignArgs = {
  id: Scalars['String'];
};


export type MutationAssignArtistArgs = {
  input?: InputMaybe<ArtistAssignInput>;
};


export type MutationAssignTagArgs = {
  input?: InputMaybe<TagAssignInput>;
};


export type MutationAssignUserOktaGroupArgs = {
  email: Scalars['String'];
};


export type MutationConfirmProductChartMatchArgs = {
  id: Scalars['String'];
};


export type MutationCountCampaignViewsArgs = {
  input?: InputMaybe<CountCampaignViewsInput>;
};


export type MutationCreateAlterNameArgs = {
  input?: InputMaybe<AlterNameCreate>;
};


export type MutationCreateArtistArgs = {
  input?: InputMaybe<ArtistCreate>;
};


export type MutationCreateCampaignArgs = {
  input?: InputMaybe<CampaignCreate>;
};


export type MutationCreateChartConfigurationArgs = {
  input?: InputMaybe<ChartConfigurationCreateInput>;
};


export type MutationCreateCommentArgs = {
  argument_id: Scalars['String'];
  campaign_id?: InputMaybe<Scalars['String']>;
  text: Scalars['String'];
};


export type MutationCreateFeedArgs = {
  input?: InputMaybe<FeedCreate>;
};


export type MutationCreateGlobalInboxItemArgs = {
  input?: InputMaybe<GlobalInboxItemCreate>;
};


export type MutationCreateLabelArgs = {
  input?: InputMaybe<LabelInput>;
};


export type MutationCreateLabelTemplateArgs = {
  input?: InputMaybe<CreateLabelTemplate>;
};


export type MutationCreateLocalProductArgs = {
  input?: InputMaybe<ProductLocalCreateInput>;
};


export type MutationCreateOktaUserArgs = {
  input: OktaUserInput;
};


export type MutationCreateProductsArgs = {
  input?: InputMaybe<Array<InputMaybe<ProductCreate>>>;
};


export type MutationCreateSpaceArgs = {
  input?: InputMaybe<SpaceCreate>;
};


export type MutationCreateTagArgs = {
  input?: InputMaybe<TagCreate>;
};


export type MutationCreateUnitArgs = {
  input?: InputMaybe<UnitInput>;
};


export type MutationCreateUserArgs = {
  input?: InputMaybe<UserCreate>;
};


export type MutationDeleteArtistArgs = {
  id: Scalars['String'];
};


export type MutationDeleteCampaignArgs = {
  id: Scalars['String'];
};


export type MutationDeleteChartConfigurationArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteGlobalInboxItemArgs = {
  input?: InputMaybe<DeleteGlobalInboxItemInput>;
};


export type MutationDeleteLabelArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteLabelTemplateArgs = {
  id: Scalars['String'];
};


export type MutationDeleteNotificationArgs = {
  notifications?: InputMaybe<Array<NotificationsDelete>>;
};


export type MutationDeleteNotificationsV2Args = {
  notification_type?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteSpaceArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteTagArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteUnitArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteUserArgs = {
  id: Scalars['Int'];
};


export type MutationEditCommentArgs = {
  id: Scalars['String'];
  text: Scalars['String'];
};


export type MutationFollowCampaignArgs = {
  campaign_id: Scalars['String'];
};


export type MutationFollowLabelArgs = {
  label_id: Scalars['String'];
};


export type MutationFollowTagArgs = {
  tag_id: Scalars['String'];
};


export type MutationGlobalizeCampaignArgs = {
  id: Scalars['String'];
};


export type MutationLocalizeCampaignArgs = {
  input?: InputMaybe<CampaignLocalize>;
};


export type MutationMakeStoryGlobalArgs = {
  id: Scalars['String'];
  text?: InputMaybe<Scalars['String']>;
};


export type MutationPinStoryArgs = {
  projectId: Scalars['String'];
  storyId: Scalars['String'];
};


export type MutationProcessGlobalInboxItemArgs = {
  input?: InputMaybe<GlobalInboxItemUpdate>;
};


export type MutationPublishGlobalCampaignArgs = {
  id: Scalars['String'];
};


export type MutationRemoveAlterNameArgs = {
  id: Scalars['String'];
};


export type MutationRemoveCampaignArgs = {
  id: Scalars['String'];
};


export type MutationRemoveCommentArgs = {
  id: Scalars['String'];
};


export type MutationRemoveFeedArgs = {
  id: Scalars['String'];
};


export type MutationRemoveLocalProductArgs = {
  id: Scalars['String'];
};


export type MutationRemoveProductArgs = {
  id: Scalars['String'];
};


export type MutationReportArgs = {
  input?: InputMaybe<ReportInput>;
};


export type MutationRestoreUserArgs = {
  id: Scalars['Int'];
};


export type MutationSelectCreateGlobalFeedArgs = {
  input?: InputMaybe<FeedGlobalCreateUpdate>;
};


export type MutationSetSpotifyArtistUrlArgs = {
  id: Scalars['String'];
  spotifyUrl: Scalars['String'];
};


export type MutationSubscribeToPushNotificationsArgs = {
  subscription_info: Scalars['String'];
  user_id: Scalars['String'];
};


export type MutationUnSubscribeFromPushNotificationsArgs = {
  user_id: Scalars['String'];
};


export type MutationUnassignArtistArgs = {
  input?: InputMaybe<ArtistAssignInput>;
};


export type MutationUnassignTagArgs = {
  input?: InputMaybe<TagAssignInput>;
};


export type MutationUnfollowCampaignArgs = {
  campaign_id: Scalars['String'];
};


export type MutationUnfollowLabelArgs = {
  label_id: Scalars['String'];
};


export type MutationUnfollowTagArgs = {
  tag_id: Scalars['String'];
};


export type MutationUnpinStoryArgs = {
  projectId: Scalars['String'];
};


export type MutationUpdateArtistArgs = {
  input?: InputMaybe<ArtistUpdate>;
};


export type MutationUpdateCampaignArgs = {
  input?: InputMaybe<CampaignUpdate>;
};


export type MutationUpdateCampaignTeamInfoArgs = {
  input?: InputMaybe<CampaignUpdateTeamInfo>;
};


export type MutationUpdateChartConfigurationArgs = {
  input?: InputMaybe<ChartConfigurationUpdateInput>;
};


export type MutationUpdateFactSourceItemArgs = {
  input?: InputMaybe<UpdateFactSource>;
};


export type MutationUpdateFeedArgs = {
  input?: InputMaybe<FeedUpdate>;
};


export type MutationUpdateFeedCampaignArgs = {
  input?: InputMaybe<FeedUpdate>;
};


export type MutationUpdateGlobalCampaignArgs = {
  input?: InputMaybe<CampaignUpdate>;
};


export type MutationUpdateInfoMessageArgs = {
  input?: InputMaybe<InfoMessageUpdate>;
};


export type MutationUpdateLabelArgs = {
  input?: InputMaybe<LabelInput>;
};


export type MutationUpdateLabelTemplateArgs = {
  id: Scalars['String'];
  template: Scalars['String'];
};


export type MutationUpdateLocalProductArgs = {
  input?: InputMaybe<ProductLocalUpdateInput>;
};


export type MutationUpdateProductArgs = {
  input?: InputMaybe<ProductUpdate>;
};


export type MutationUpdateSpaceArgs = {
  input?: InputMaybe<SpaceUpdate>;
};


export type MutationUpdateTagArgs = {
  input?: InputMaybe<TagUpdate>;
};


export type MutationUpdateUnitArgs = {
  input?: InputMaybe<UnitInput>;
};


export type MutationUpdateUserArgs = {
  input?: InputMaybe<UserUpdate>;
};


export type MutationWipeUserArgs = {
  id: Scalars['Int'];
};

export type Notification = Entity & {
  __typename?: 'Notification';
  argument_id?: Maybe<Scalars['String']>;
  artist_name?: Maybe<Scalars['String']>;
  campaign_id?: Maybe<Scalars['String']>;
  campaign_name?: Maybe<Scalars['String']>;
  campaign_owner?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  product_id?: Maybe<Scalars['String']>;
  product_name?: Maybe<Scalars['String']>;
  release_date?: Maybe<Scalars['String']>;
  story_id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

export type NotificationDeleteResponse = {
  __typename?: 'NotificationDeleteResponse';
  result?: Maybe<Scalars['String']>;
};

export type NotificationNext = Entity & {
  __typename?: 'NotificationNext';
  campaign?: Maybe<Campaign>;
  created_at?: Maybe<Scalars['AWSDate']>;
  id: Scalars['String'];
  notification_type: Scalars['String'];
  product?: Maybe<Product>;
  properties?: Maybe<NotificationProps>;
  story?: Maybe<Feed>;
  story_id?: Maybe<Scalars['String']>;
};

export type NotificationProps = {
  __typename?: 'NotificationProps';
  gcdm_matches?: Maybe<Array<Maybe<GcdmMatch>>>;
  initial_release_date?: Maybe<Scalars['String']>;
};

export type NotificationsDelete = {
  id?: InputMaybe<Scalars['String']>;
  notification_type?: InputMaybe<Scalars['String']>;
};

export type OktaUser = Entity & {
  __typename?: 'OktaUser';
  activation?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  profile?: Maybe<Profile>;
};

export type OktaUserGroupResponse = {
  __typename?: 'OktaUserGroupResponse';
  result?: Maybe<Scalars['String']>;
};

export type OktaUserInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  labelId?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
};

export type Product = Entity & {
  __typename?: 'Product';
  active?: Maybe<Scalars['Boolean']>;
  alter_names?: Maybe<Array<Maybe<AlterName>>>;
  artist_id?: Maybe<Scalars['String']>;
  campaign?: Maybe<Campaign>;
  campaign_id?: Maybe<Scalars['Int']>;
  configuration?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  dsp_updates?: Maybe<Scalars['Boolean']>;
  dv_entity_id?: Maybe<Scalars['String']>;
  dv_group_id?: Maybe<Scalars['String']>;
  facts?: Maybe<Array<Maybe<Fact>>>;
  gpid?: Maybe<Scalars['String']>;
  gpid_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  gps_status?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['String']>;
  properties?: Maybe<ProductProps>;
  publish_date?: Maybe<Scalars['String']>;
  radio_updates?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['String']>;
  zone?: Maybe<Label>;
};

export type ProductChartSimilarity = Entity & {
  __typename?: 'ProductChartSimilarity';
  artist_chart_name: Scalars['String'];
  artist_name: Scalars['String'];
  configuration: Scalars['String'];
  dv_entity_id: Scalars['String'];
  id: Scalars['String'];
  product_chart_name: Scalars['String'];
  product_id: Scalars['Int'];
  product_name: Scalars['String'];
  score: Scalars['Float'];
};

export type ProductChartSimilarityResponse = {
  __typename?: 'ProductChartSimilarityResponse';
  items: Array<ProductChartSimilarity>;
  total: Scalars['Int'];
};

export enum ProductConfiguration {
  Album = 'album',
  All = 'all',
  Single = 'single'
}

export type ProductCreate = {
  artist_id: Scalars['String'];
  configuration: ProductType;
  dv_entity_id?: InputMaybe<Scalars['String']>;
  dv_group_id?: InputMaybe<Scalars['String']>;
  gpid_list?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gps_status?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type ProductFilters = {
  configuration?: InputMaybe<Scalars['String']>;
  followed?: InputMaybe<Scalars['String']>;
  gps_status?: InputMaybe<Scalars['String']>;
  label_id?: InputMaybe<Scalars['String']>;
  range?: InputMaybe<Scalars['String']>;
  space_id?: InputMaybe<Scalars['String']>;
  unit_id?: InputMaybe<Scalars['String']>;
};

export type ProductInput = {
  filters?: InputMaybe<ProductFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ProductOrder>;
};

export type ProductLocalCreateInput = {
  active: Scalars['Boolean'];
  campaign_id?: InputMaybe<Scalars['String']>;
  dsp_updates?: InputMaybe<Scalars['Boolean']>;
  label_id?: InputMaybe<Scalars['String']>;
  main: Scalars['Boolean'];
  product_id: Scalars['String'];
  publish_date: Scalars['String'];
  radio_updates?: InputMaybe<Scalars['Boolean']>;
};

export type ProductLocalUpdateInput = {
  active: Scalars['Boolean'];
  dsp_updates?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  main: Scalars['Boolean'];
  publish_date: Scalars['String'];
  radio_updates?: InputMaybe<Scalars['Boolean']>;
};

export type ProductOrder = {
  direction: SortOrder;
  fieldName: ProductSortField;
};

export type ProductProps = {
  __typename?: 'ProductProps';
  initial_release_date?: Maybe<Scalars['String']>;
};

export type ProductResponse = {
  __typename?: 'ProductResponse';
  products?: Maybe<Array<Maybe<Product>>>;
  total?: Maybe<Scalars['Int']>;
};

export enum ProductSortField {
  DateAdded = 'dateAdded',
  GpsStatus = 'gpsStatus',
  ProjectOwner = 'projectOwner',
  ReleaseDate = 'releaseDate',
  Type = 'type',
  Unit = 'unit'
}

export type ProductSorts = {
  dateAdded?: InputMaybe<SortOrder>;
  projectOwner?: InputMaybe<SortOrder>;
  releaseDate?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  unit?: InputMaybe<SortOrder>;
};

export enum ProductType {
  Album = 'album',
  Ep = 'ep',
  Single = 'single'
}

export type ProductUpdate = {
  configuration?: InputMaybe<Scalars['String']>;
  dv_entity_id?: InputMaybe<Scalars['String']>;
  dv_group_id?: InputMaybe<Scalars['String']>;
  gpid_list?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gps_status?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  local?: InputMaybe<ProductLocalUpdateInput>;
  name?: InputMaybe<Scalars['String']>;
};

export type ProductsStatistic = {
  __typename?: 'ProductsStatistic';
  count?: Maybe<Array<Maybe<ProductsStatisticCount>>>;
  countByRange?: Maybe<Array<Maybe<ProductsStatisticCountByRange>>>;
};

export type ProductsStatisticCount = {
  __typename?: 'ProductsStatisticCount';
  label_id?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  unit_id?: Maybe<Scalars['String']>;
};

export type ProductsStatisticCountByRange = {
  __typename?: 'ProductsStatisticCountByRange';
  count?: Maybe<Scalars['Int']>;
  label_id?: Maybe<Scalars['String']>;
  range?: Maybe<Scalars['String']>;
  unit_id?: Maybe<Scalars['String']>;
};

export type Profile = {
  __typename?: 'Profile';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  homeOrg?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  managementCompany?: Maybe<Scalars['String']>;
  mobilePhone?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

export type ProjectFilters = {
  archived?: InputMaybe<FilterArchivedStatus>;
  is_global?: InputMaybe<Scalars['Boolean']>;
  label_id?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  owners?: InputMaybe<Scalars['String']>;
  relation_type?: InputMaybe<ProjectRelationType>;
  unit_id?: InputMaybe<Scalars['String']>;
  with_gps?: InputMaybe<Scalars['Boolean']>;
};

export type ProjectOrder = {
  direction: SortOrder;
  field_name: ProjectSortField;
};

export enum ProjectRelationType {
  All = 'all',
  Followed = 'followed',
  My = 'my'
}

export enum ProjectSortField {
  CreatedAt = 'created_at',
  Name = 'name'
}

export type ProjectsResponse = {
  __typename?: 'ProjectsResponse';
  projects?: Maybe<Array<Campaign>>;
  total?: Maybe<Scalars['Int']>;
};

export type Query = {
  __typename?: 'Query';
  findUserByEmail: User;
  getAllCharts?: Maybe<Array<Maybe<Chart>>>;
  getAllFinances?: Maybe<Array<Maybe<Finance>>>;
  getAllSpaceUnits?: Maybe<Array<Unit>>;
  getArtist?: Maybe<Artist>;
  getArtistProducts?: Maybe<Array<GlobalProduct>>;
  getArtists: ArtistsResponse;
  getArtistsByName?: Maybe<Array<Maybe<Artist>>>;
  getCampaign?: Maybe<Campaign>;
  getCampaignByName?: Maybe<CampaignByName>;
  getCampaignViews: Array<GetCampaignViewsResponse>;
  getCampaigns?: Maybe<ArtistsResponse>;
  getCampaignsStatistic?: Maybe<CampaignStatistic>;
  getChartConfigurationByLabelId?: Maybe<Array<Maybe<ChartConfiguration>>>;
  getChartsByLabelIdAndCountry?: Maybe<Array<Maybe<GetChartsByLabelIdAndCountryResponse>>>;
  getChartsByName?: Maybe<Array<ChartName>>;
  getChartsBySpaceIdAndCountry?: Maybe<Array<Maybe<GetChartsByLabelIdAndCountryResponse>>>;
  getCountryCharts?: Maybe<Array<Maybe<Chart>>>;
  getCountryList?: Maybe<Array<Maybe<Country>>>;
  getDVCharts?: Maybe<GetDvChartsResponse>;
  getFactSourceItems: SourceItemResponse;
  getFactSources: Array<FactSource>;
  getFacts?: Maybe<Array<Maybe<Fact>>>;
  getFeeds: FeedResponse;
  getFeedsByCampaignId?: Maybe<FeedResponse>;
  getFinancesByProjectId?: Maybe<Finance>;
  getGlobalInbox?: Maybe<GlobalInboxResponse>;
  getGlobalizerFeedsByCampaignId?: Maybe<FeedResponse>;
  getGpsUnits?: Maybe<Array<Unit>>;
  getInfoMessage?: Maybe<InfoMessage>;
  getInternalDomains: Array<Scalars['String']>;
  getLabelAssigns?: Maybe<Array<Maybe<TagAssigns>>>;
  getLabelById?: Maybe<Label>;
  getLabelStoryGuide?: Maybe<LabelTemplate>;
  getLabelTags?: Maybe<Array<Maybe<Tag>>>;
  getLabelTemplates?: Maybe<Array<LabelTemplate>>;
  getLabels: Array<Label>;
  getLatestChartsByCountryCode?: Maybe<Array<Maybe<ChartFreshness>>>;
  getNewReleases?: Maybe<ProductResponse>;
  getNotifications?: Maybe<Array<NotificationNext>>;
  getProductChartMatchList: ProductChartSimilarityResponse;
  getProductVersions?: Maybe<ArtistProductSearchResponse>;
  getProductsByCampaignId?: Maybe<Array<Maybe<Product>>>;
  getProductsStatistic?: Maybe<ProductsStatistic>;
  getProjects?: Maybe<ProjectsResponse>;
  getRoles?: Maybe<Array<Role>>;
  getSpace: Space;
  getSpaces: Array<Space>;
  getStoriesStatistic?: Maybe<StoryStatistic>;
  getStoriesStatisticPerRange?: Maybe<Array<Maybe<StoryStatisticCountByRange>>>;
  getStory: Feed;
  getTags: Array<Tag>;
  getTopChartingProducts?: Maybe<Array<Chart>>;
  getUnits?: Maybe<Array<Unit>>;
  getUpcomingArtistConcerts: UpcomingArtistConcertsResponse;
  getUpcomingConcerts: GetUpcomingConcertsResponse;
  getUser: User;
  getUserFollows?: Maybe<Array<Maybe<Follow>>>;
  getUserLabelFollows?: Maybe<Array<Maybe<LabelFollow>>>;
  getUserTagFollows?: Maybe<Array<TagFollow>>;
  getUsers: Array<User>;
  getZonesWithGlobalProjects?: Maybe<Array<Label>>;
  importConcerts: ImportConcertsResponse;
  listUsers: UserResponse;
  search?: Maybe<Search>;
  searchArtistProducts?: Maybe<ArtistProductSearchResponse>;
  searchGcdmArtists?: Maybe<GcdmArtistSearchResponse>;
  searchGcdmProducts?: Maybe<GcdmProductSearchResponse>;
  searchGlobal?: Maybe<Array<Maybe<Campaign>>>;
  searchProducts?: Maybe<ArtistProductSearchResponse>;
  searchUsers: Array<User>;
  showMyFilterForZone: Scalars['Boolean'];
};


export type QueryFindUserByEmailArgs = {
  email: Scalars['String'];
};


export type QueryGetAllSpaceUnitsArgs = {
  space_id: Scalars['String'];
};


export type QueryGetArtistArgs = {
  id: Scalars['String'];
};


export type QueryGetArtistProductsArgs = {
  artist_id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
};


export type QueryGetArtistsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryGetArtistsByNameArgs = {
  name: Scalars['String'];
};


export type QueryGetCampaignArgs = {
  id: Scalars['String'];
};


export type QueryGetCampaignByNameArgs = {
  is_global?: InputMaybe<Scalars['Boolean']>;
  label_id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  space_id?: InputMaybe<Scalars['String']>;
};


export type QueryGetCampaignViewsArgs = {
  input: GetCampaignViewsInput;
};


export type QueryGetCampaignsArgs = {
  filters?: InputMaybe<CampaignsFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetCampaignsStatisticArgs = {
  from?: InputMaybe<Scalars['String']>;
  range: DateRangeParameter;
  to?: InputMaybe<Scalars['String']>;
};


export type QueryGetChartConfigurationByLabelIdArgs = {
  label_id?: InputMaybe<Scalars['Int']>;
};


export type QueryGetChartsByLabelIdAndCountryArgs = {
  countryCode: Scalars['String'];
  label_id: Scalars['String'];
};


export type QueryGetChartsByNameArgs = {
  name: Scalars['String'];
  type: ChartNameTypeParameter;
};


export type QueryGetChartsBySpaceIdAndCountryArgs = {
  countryCode: Scalars['String'];
  space_id: Scalars['String'];
};


export type QueryGetCountryChartsArgs = {
  countryCode: Scalars['String'];
};


export type QueryGetDvChartsArgs = {
  input?: InputMaybe<GetDvChartsInput>;
};


export type QueryGetFactSourceItemsArgs = {
  input?: InputMaybe<FilterFactSource>;
};


export type QueryGetFeedsArgs = {
  filters?: InputMaybe<FeedFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryGetFeedsByCampaignIdArgs = {
  campaignId: Scalars['String'];
  country?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Array<InputMaybe<FeedTagFilter>>>;
  includePeakStories?: InputMaybe<Scalars['Boolean']>;
  isPreview?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  textFilter?: InputMaybe<Scalars['String']>;
  zone?: InputMaybe<Scalars['String']>;
};


export type QueryGetFinancesByProjectIdArgs = {
  projectId: Scalars['String'];
};


export type QueryGetGlobalInboxArgs = {
  filters?: InputMaybe<InboxFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryGetGlobalizerFeedsByCampaignIdArgs = {
  campaignId: Scalars['String'];
  filter?: InputMaybe<Array<InputMaybe<FeedTagFilter>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryGetLabelAssignsArgs = {
  labelId?: InputMaybe<Scalars['String']>;
};


export type QueryGetLabelByIdArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryGetLabelTagsArgs = {
  input?: InputMaybe<LabelTagsInput>;
};


export type QueryGetLabelTemplatesArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryGetLatestChartsByCountryCodeArgs = {
  countryCode: Scalars['String'];
};


export type QueryGetNewReleasesArgs = {
  input?: InputMaybe<ProductInput>;
};


export type QueryGetNotificationsArgs = {
  country?: InputMaybe<Scalars['String']>;
};


export type QueryGetProductVersionsArgs = {
  configuration: ArtistProductType;
  dv_entity_id: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryGetProductsByCampaignIdArgs = {
  campaignId: Scalars['String'];
  countryCode?: InputMaybe<Scalars['String']>;
};


export type QueryGetProductsStatisticArgs = {
  from?: InputMaybe<Scalars['String']>;
  range: DateRangeParameter;
  to?: InputMaybe<Scalars['String']>;
};


export type QueryGetProjectsArgs = {
  filters?: InputMaybe<ProjectFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ProjectOrder>;
};


export type QueryGetSpaceArgs = {
  id: Scalars['String'];
};


export type QueryGetStoriesStatisticPerRangeArgs = {
  from?: InputMaybe<Scalars['String']>;
  range: DateRangeParameter;
  to?: InputMaybe<Scalars['String']>;
};


export type QueryGetStoryArgs = {
  id: Scalars['String'];
};


export type QueryGetTagsArgs = {
  input?: InputMaybe<LabelTagsInput>;
};


export type QueryGetTopChartingProductsArgs = {
  countryCode: Scalars['String'];
  label_id?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  space_id?: InputMaybe<Scalars['String']>;
};


export type QueryGetUpcomingArtistConcertsArgs = {
  artistId: Scalars['String'];
  countryIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryGetUpcomingConcertsArgs = {
  input: GetUpcomingConcertsInput;
};


export type QueryGetUserArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type QueryListUsersArgs = {
  filters?: InputMaybe<UsersFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchArgs = {
  is_global?: InputMaybe<Scalars['Boolean']>;
  label_id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  space_id?: InputMaybe<Scalars['String']>;
};


export type QuerySearchArtistProductsArgs = {
  artistId: Scalars['String'];
  configuration: ArtistProductType;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  productName: Scalars['String'];
  useExtendedSearch?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySearchGcdmArtistsArgs = {
  input?: InputMaybe<GcdmArtistSearchInput>;
};


export type QuerySearchGcdmProductsArgs = {
  input?: InputMaybe<GcdmProductSearchInput>;
};


export type QuerySearchGlobalArgs = {
  global_status?: InputMaybe<Array<InputMaybe<GlobalStatus>>>;
  isParent?: InputMaybe<Scalars['Boolean']>;
  label_id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};


export type QuerySearchProductsArgs = {
  configuration: ArtistProductType;
  limit?: InputMaybe<Scalars['Int']>;
  productName: Scalars['String'];
};


export type QuerySearchUsersArgs = {
  name?: InputMaybe<Scalars['String']>;
};


export type QueryShowMyFilterForZoneArgs = {
  zoneId?: InputMaybe<Scalars['String']>;
};

export type ReportInput = {
  artist: Scalars['String'];
  campaign: Scalars['String'];
  category: Scalars['String'];
  message?: InputMaybe<Scalars['String']>;
};

export enum ReviewStatus {
  Open = 'OPEN',
  Processed = 'PROCESSED'
}

export type Role = Entity & {
  __typename?: 'Role';
  can_assign_external?: Maybe<Scalars['Boolean']>;
  default?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type Search = {
  __typename?: 'Search';
  campaigns?: Maybe<Array<Campaign>>;
  products?: Maybe<Array<Product>>;
};

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SourceItem = {
  __typename?: 'SourceItem';
  category?: Maybe<Scalars['String']>;
  chart?: Maybe<Scalars['String']>;
  chart_id?: Maybe<Scalars['String']>;
  configuration?: Maybe<Scalars['String']>;
  country_code?: Maybe<Scalars['String']>;
  cycle?: Maybe<Scalars['String']>;
  gfk_id?: Maybe<Scalars['Int']>;
  import_date_offset?: Maybe<Scalars['Int']>;
  import_limit?: Maybe<Scalars['Int']>;
  release_info?: Maybe<Scalars['String']>;
  visible?: Maybe<Scalars['Boolean']>;
};

export type SourceItemResponse = {
  __typename?: 'SourceItemResponse';
  items: Array<SourceItem>;
  total?: Maybe<Scalars['Int']>;
};

export type Space = Entity & {
  __typename?: 'Space';
  alias: Scalars['String'];
  id: Scalars['String'];
  labels: Array<Label>;
  name: Scalars['String'];
};

export type SpaceCreate = {
  alias: Scalars['String'];
  labels: Array<Scalars['ID']>;
  name: Scalars['String'];
};

export type SpaceUpdate = {
  alias?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
};

export type StoryStatistic = {
  __typename?: 'StoryStatistic';
  count?: Maybe<Array<Maybe<StoryStatisticCount>>>;
  countByCampaigns?: Maybe<Array<Maybe<StoryStatisticCountCountByCampaigns>>>;
  countByTags?: Maybe<Array<Maybe<StoryStatisticCountCountByTags>>>;
};

export type StoryStatisticCount = {
  __typename?: 'StoryStatisticCount';
  label_id?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  unit_id?: Maybe<Scalars['String']>;
};

export type StoryStatisticCountByRange = {
  __typename?: 'StoryStatisticCountByRange';
  count?: Maybe<Scalars['Int']>;
  label_id?: Maybe<Scalars['String']>;
  range?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  unit_id?: Maybe<Scalars['String']>;
};

export type StoryStatisticCountCountByCampaigns = {
  __typename?: 'StoryStatisticCountCountByCampaigns';
  artist_name?: Maybe<Scalars['String']>;
  campaign_id?: Maybe<Scalars['String']>;
  campaign_name?: Maybe<Scalars['String']>;
  label_id?: Maybe<Scalars['String']>;
  rank?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type StoryStatisticCountCountByTags = {
  __typename?: 'StoryStatisticCountCountByTags';
  name?: Maybe<Scalars['String']>;
  tags_id?: Maybe<Scalars['String']>;
  tags_label_id?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  artistSubscription?: Maybe<Artist>;
};


export type SubscriptionArtistSubscriptionArgs = {
  id?: InputMaybe<Scalars['String']>;
};

export type Tag = Entity & {
  __typename?: 'Tag';
  id: Scalars['String'];
  label: Scalars['String'];
  label_id?: Maybe<Scalars['String']>;
  order_number: Scalars['Int'];
};

export type TagAssignInput = {
  labelId: Scalars['String'];
  tagId: Scalars['String'];
};

export type TagAssignResponse = {
  __typename?: 'TagAssignResponse';
  result?: Maybe<Scalars['String']>;
};

export type TagAssigns = Entity & {
  __typename?: 'TagAssigns';
  id?: Maybe<Scalars['String']>;
  label_id?: Maybe<Scalars['String']>;
  tag_id?: Maybe<Scalars['String']>;
};

export type TagCreate = {
  label: Scalars['String'];
  label_id: Scalars['String'];
  order_number: Scalars['Int'];
};

export type TagFollow = Entity & {
  __typename?: 'TagFollow';
  id?: Maybe<Scalars['String']>;
  tag_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

export type TagFollowInput = {
  tag_id: Scalars['String'];
};

export type TagInput = {
  id?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  order_number?: InputMaybe<Scalars['Int']>;
};

export type TagUpdate = {
  id: Scalars['String'];
  label: Scalars['String'];
  order_number: Scalars['Int'];
};

export type Unit = Entity & {
  __typename?: 'Unit';
  alias: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type UnitInput = {
  id?: InputMaybe<Scalars['String']>;
  label_id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type UpcomingArtistConcertsResponse = {
  __typename?: 'UpcomingArtistConcertsResponse';
  concerts: Array<ArtistConcert>;
  totalConcertCount: Scalars['Int'];
};

export type UpdateFactSource = {
  chart?: InputMaybe<Scalars['String']>;
  chart_id?: InputMaybe<Scalars['String']>;
};

export type User = Entity & {
  __typename?: 'User';
  abilities: Abilities;
  assigned_campaigns?: Maybe<Array<Campaign>>;
  country_code: Scalars['String'];
  email: Scalars['String'];
  first_name: Scalars['String'];
  id: Scalars['String'];
  is_active: Scalars['Boolean'];
  is_external: Scalars['Boolean'];
  label_id?: Maybe<Scalars['String']>;
  last_name: Scalars['String'];
  region_id?: Maybe<Scalars['String']>;
  role: UserRole;
  space_id?: Maybe<Scalars['String']>;
  unit_id?: Maybe<Scalars['String']>;
};

export type UserCreate = {
  assigned_campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  country_code?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  first_name: Scalars['String'];
  label_id?: InputMaybe<Scalars['String']>;
  last_name: Scalars['String'];
  role?: InputMaybe<UserRoleInput>;
  space_id?: InputMaybe<Scalars['String']>;
  unit_id?: InputMaybe<Scalars['String']>;
};

export type UserResponse = {
  __typename?: 'UserResponse';
  total?: Maybe<Scalars['String']>;
  users?: Maybe<Array<User>>;
};

export type UserRole = {
  __typename?: 'UserRole';
  expire_at?: Maybe<Scalars['String']>;
  role_id: Scalars['String'];
};

export type UserRoleInput = {
  expire_at?: InputMaybe<Scalars['String']>;
  role_id: Scalars['String'];
};

export type UserUpdate = {
  assigned_campaigns?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  country_code?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  first_name?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  label_id?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<UserRoleInput>;
  space_id?: InputMaybe<Scalars['String']>;
  unit_id?: InputMaybe<Scalars['String']>;
};

export type UsersFilters = {
  is_external?: InputMaybe<Scalars['Boolean']>;
  label_id?: InputMaybe<Scalars['String']>;
  role_id?: InputMaybe<Scalars['String']>;
  space_id?: InputMaybe<Scalars['String']>;
  unit_id?: InputMaybe<Scalars['String']>;
};
